"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconArrowUp = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconArrowUp = function IconArrowUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.35 14.81l-2.7 2.95L12 11.67l-6.65 6.09-2.7-2.95L12 6.24l9.35 8.57z"
  }));
};
exports.IconArrowUp = IconArrowUp;